@if ((loading$ | async) === false) {
  <div
    class="flex flex-col w-full">
    <div class="font-bold text-sm text-primary-400 mt-2 mb-1">
      {{'#LLR_KOMMISSIONIERUNG.EMBALLAGEN_ERFASSUNG.TITEL_EMBALLAGEN' | translate}}
    </div>
    @if (emballagen(); as emballagen) {
      @if (emballagen.length > 0) {
        <div>
          @for (emballage of emballagen; track emballage) {
            <div class="soft-card rounded-sm flex flex-row w-full items-center justify-between mb-3 !p-3"
              >
              <div class="flex flex-row w-full justify-between">
                <div class="flex flex-col w-auto md:w-1/2 lg:w-2/3 gap-2">
                  <div class="flex flex-row w-full">
                    <div class="text-sm text-gray-400">
                      {{emballage?.bewebs?.artikel?.artikelnummer}}
                    </div>
                  </div>
                  <div class="flex flex-row w-full">
                    <div class="font-semibold">
                      {{emballage?.bewebs?.artikel?.artkurzbez ?? 'Emballage'}}
                    </div>
                  </div>
                </div>
                <div class="flex flex-row w-auto md:w-1/2 lg:w-1/3 gap-4 self-center justify-end">
                  <soft-mengen-eingabe
                    #emballageMengeInput
                    [float]="true"
                    [negativeValuesValid]="true"
                    [value]="emballage?.kommissionierDaten?.menge ?? 0"
                    (valueChange)="updateEmballageMengeLocal(emballageMengeInput.value ?? 0, emballage)"
                    [einheit]="emballage?.arteh?.arteh ?? ''">
                  </soft-mengen-eingabe>
                </div>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="flex text-sm text-lighter w-full justify-center items-center mt-3">
          {{'#LLR_KOMMISSIONIERUNG.EMBALLAGEN_ERFASSUNG.LABEL_KEINE_EMBALLAGEN_VORHANDEN' | translate}}
        </div>
      }
    }
  </div>
} @else {
  <div class="flex flex-col pb-5 gap-2">
    <div class="h-4 w-16 skeleton rounded mt-3"></div>
    <div class="flex soft-card rounded w-full h-24" *softRepeat="5">
      <div class="flex flex-col gap-2 items-start pb-1.5 pt-2">
        <div class="h-4 w-20 skeleton rounded"></div>
        <div class="h-4 w-24 skeleton rounded"></div>
        <div class="h-4 w-36 skeleton rounded"></div>
      </div>
    </div>
  </div>
}

